<template>
  <v-container>
    <v-row v-if="value.src">
      <v-col cols="12">
        <v-card color="background" rounded="0" variant="flat">
          <iframe
            :src="value.src"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            scrolling="yes"
            style="
              border: none;
              display: block;
              overflow-y: scroll;
              margin: 0;
              padding: 0;
              width: 100%;
              height: 900px;
            "
          ></iframe>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
